export { ManageFacultyPage } from './ManageFacultyPage'
